import MailboxJunkEmailConfigurationOptions from 'owa-service/lib/contract/MailboxJunkEmailConfigurationOptions';
import { initMailboxJunkEmailConfiguration } from 'owa-junkmail-configuration';
import store from '../store/store';

/**
 * Returns the mailbox junk email configuration object which is observable
 */
export default async function getMailboxJunkEmailConfiguration(): Promise<
    MailboxJunkEmailConfigurationOptions
> {
    // Load if the configuration is not set
    if (!store.mailboxJunkEmailConfiguration) {
        await initMailboxJunkEmailConfiguration();
    }

    return store.mailboxJunkEmailConfiguration;
}
